export const PROMO_STORE_MENU_BUILT_INS = [
  { type: "home", label: "Home" },
  { type: "shop", label: "Shop" },
  { type: "cart", label: "Cart" },
  { type: "checkout", label: "Checkout" },
  { type: "my-account", label: "My Account" },
];

export const sanitizePromoStoreMenuUrl = (value) => {
  const url = String(value || "").trim();
  if (!url || /^javascript:/i.test(url) || /^data:/i.test(url)) return "";
  if (/^(https?:\/\/|mailto:|tel:|\/)/i.test(url)) return url;
  return "";
};

export const ensurePromoStoreMenuConfig = (templateConfig = {}) => {
  const source = templateConfig && typeof templateConfig === "object" ? templateConfig : {};
  const menu = source.menu && typeof source.menu === "object" ? source.menu : {};
  const locations = menu.locations && typeof menu.locations === "object" ? menu.locations : {};
  const items = Array.isArray(menu.items) ? menu.items : [];

  return {
    locations: { header: locations.header === true, footer: locations.footer === true },
    items: items
      .filter((item) => item && typeof item === "object" && item.id && item.type)
      .map((item) => ({
        id: String(item.id),
        type: String(item.type),
        label: String(item.label || ""),
        ...(item.type === "category" ? { categoryId: item.categoryId } : {}),
        ...(item.type === "custom-link" ? { url: sanitizePromoStoreMenuUrl(item.url) } : {}),
      })),
  };
};

export const setPromoStoreMenuConfig = (templateConfig = {}, menu) => ({
  ...(templateConfig || {}),
  menu: ensurePromoStoreMenuConfig({ menu }),
});

export const createPromoStoreMenuItemId = () =>
  `menu-item-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
